
import { queryOptions } from "@tanstack/react-query";
import axios from 'axios';

export interface SmartySuggestion {
  street_line: string;
  city: string;
  state: string;
  zipcode: string;
}

export const smarty = axios.create({
  baseURL: import.meta.env['VITE_SMARTY_API_URL'],
});

export const fetchSmartySuggestions = async (input: string) => {
  if (!input || input.length < 3) return [];
  const authId = import.meta.env['VITE_SMARTY_AUTH_ID'];
  const params = new URLSearchParams();
  params.append('key', authId);
  params.append('search', input);
  const res = await smarty.get(`/lookup?${params.toString()}`);
  return res.data.suggestions || [];
};

export const smartyAutocompleteOptions = (input: string) =>
  queryOptions<SmartySuggestion[]>({
    queryKey: ['smartyAutocomplete', input],
    queryFn: () => fetchSmartySuggestions(input),
    enabled: !!input && input.length >= 3,
  });

